import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { useLanguage } from "../i18n";
import { pizzaCategories, ristoranteMenu, extras, CONTACTS } from "../data/menu";
import { MenuBlock } from "../components/MenuBlock";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { scrollToId } from "../components/Navbar";

const Extras = () => {
  const { t } = useLanguage();
  return (
    <Reveal className="max-w-7xl mx-auto px-6 lg:px-10 pb-10">
      <div data-testid="extras-strip" className="rounded-xl border border-line bg-surface px-8 py-8">
        <p className="text-xs tracking-[0.3em] uppercase text-terra mb-5">{t("extras_title")}</p>
        <div className="flex flex-wrap gap-x-10 gap-y-3">
          {extras.map((e) => (
            <span key={e.name} className="text-sm text-ink/80 font-light" data-testid={`extra-${e.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              {e.name} <span className="text-gold font-accent ml-1">€ {e.price}</span>
            </span>
          ))}
        </div>
      </div>
    </Reveal>
  );
};

export default function MenuPage() {
  const { t } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#ristorante") {
      setTimeout(() => scrollToId("ristorante"), 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <main data-testid="menu-page" className="pt-16">
      <MenuBlock
        id="menu"
        kicker={t("menu_kicker")}
        title={t("menu_title")}
        note={t("menu_note")}
        categories={pizzaCategories}
      />
      <Extras />
      <MenuBlock
        id="ristorante"
        title={t("ristorante_title")}
        note={`${t("ristorante_note")} ${t("ristorante_nb")}`}
        categories={ristoranteMenu}
        twoCols={false}
      />
      <Reveal className="max-w-7xl mx-auto px-6 lg:px-10 pb-24 md:pb-32">
        <a
          href={CONTACTS.phoneHref}
          data-testid="menu-call-button"
          className="inline-flex items-center gap-3 rounded-full bg-terra px-8 py-4 text-xs tracking-[0.22em] uppercase text-cream font-semibold hover:bg-ink transition-colors duration-300"
        >
          <Phone size={14} /> {t("nav_call")} — {CONTACTS.phone}
        </a>
      </Reveal>
      <Footer />
    </main>
  );
}
